/**
 * Theme A11y — Accessibility helper utilities for Shopify themes
 */
(function() {
  window.theme = window.theme || {};
  window.theme.a11y = {
    accessibleLinks: function(elements, options) {
      // Fügt Screenreader-Hinweise zu externen und in neuem Fenster öffnenden Links hinzu
      var messages = options && options.messages ? options.messages : {};
      var prefix = options && options.prefix ? options.prefix : 'a11y';

      var messageText = {
        newWindow: messages.newWindow || 'öffnet ein neues Fenster',
        external: messages.external || 'öffnet eine andere Website',
        newWindowExternal: messages.newWindowExternal || 'öffnet eine neue Seite in anderem Fenster'
      };

      function isExternal(link) {
        return link.host !== window.location.host;
      }

      Array.prototype.forEach.call(elements, function(link, index) {
        var text = messageText.external;
        var isBlank = link.target === '_blank';
        if (isBlank && isExternal(link)) {
          text = messageText.newWindowExternal;
        } else if (isBlank) {
          text = messageText.newWindow;
        }

        if (isBlank) {
          var rel = link.getAttribute('rel');
          if (!rel || rel.indexOf('noopener') < 0) {
            link.setAttribute('rel', (rel || '') + ' noopener');
          }
        }

        var id = prefix + '-message-' + index;
        var existing = document.getElementById(id);
        if (!existing) {
          var span = document.createElement('span');
          span.className = prefix + '-visually-hidden';
          span.id = id;
          span.textContent = text;
          link.appendChild(span);
          link.setAttribute('aria-describedby', id);
        }
      });
    },

    trapFocus: function(options) {
      var el = options.el;
      var focusable = el.querySelectorAll('a[href], button, textarea, input, select');
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      el.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;

        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    },

    removeTrapFocus: function() {
      // Entfernt alle Keydown-Eventlistener von Focus-Fallenziel
      document.removeEventListener('keydown', this.trapFocus);
    },

    lockMobileScrolling: function() {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    },

    unlockMobileScrolling: function() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    },

    pageLinkFocus: function(hash) {
      var el = document.getElementById(hash.replace('#', ''));
      if (el) {
        el.setAttribute('tabindex', '-1');
        el.focus();
        el.addEventListener('blur', function() {
          el.removeAttribute('tabindex');
        }, { once: true });
      }
    },

    wrapTable: function(table, tableClass) {
      var wrapper = document.createElement('div');
      wrapper.className = tableClass || 'table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    },

    accessibleForms: function(form) {
      var errors = form.querySelectorAll('[data-error]');
      Array.prototype.forEach.call(errors, function(input) {
        var field = input.closest('label') || input;
        var errSpan = document.createElement('span');
        errSpan.className = 'input-error';
        errSpan.id = input.name + '-error';
        errSpan.textContent = input.getAttribute('data-error');
        field.parentNode.insertBefore(errSpan, input.nextSibling);
        input.setAttribute('aria-describedby', errSpan.id);
        input.setAttribute('aria-invalid', 'true');
      });
    }
  };
})();
